import type { OnboardingPrefill, UserRoles } from "@shared/types";
import { apiClient } from "@/lib/api-client";

/** GET /api/v1/users/me/roles */
export async function getMyRoles(): Promise<UserRoles> {
	const response = await apiClient.get("/api/v1/users/me/roles", {
		inlineErrors: true,
	});
	const data = response.data?.data as UserRoles | undefined;
	if (!data || !Array.isArray(data.roles)) {
		throw new Error("The server did not return the roles");
	}
	return data;
}

/** GET /api/v1/users/me/onboarding-prefill */
export async function getMyOnboardingPrefill(): Promise<OnboardingPrefill> {
	const response = await apiClient.get("/api/v1/users/me/onboarding-prefill", {
		inlineErrors: true,
	});
	const data = response.data?.data as OnboardingPrefill | undefined;
	if (!data) throw new Error("The server did not return the prefill");
	return data;
}
